import { TeamRole } from '@anm/api/modules/team';
import Button from '@anm/components/buttons/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';
import { Field, Form, FormRenderProps } from 'react-final-form';
import { UserTeamPermission } from 'types/user';

import TeamMemberRolesInput from '../TeamMemberRolesInput';

import { ButtonContainer } from './Wrapper';

export type TeamRolesFormProps = {
  isPending: boolean;
  nextOwnerName: string;
  permissions?: UserTeamPermission;
  currentRole: TeamRole;
  onClose?: () => void;
};

export type TeamRolesFormFields = { role: TeamRole };

const TeamRolesForm: FC<FinalFormConfig<TeamRolesFormFields> & TeamRolesFormProps> = ({
  isPending,
  permissions,
  currentRole,
  nextOwnerName,
  onClose,
  ...props
}) => (
  <Form
    render={({ form, handleSubmit }: FormRenderProps<TeamRolesFormFields>) => (
      <form onSubmit={handleSubmit}>
        <Field
          name="role"
          permissions={permissions}
          component={TeamMemberRolesInput}
          nextOwnerName={nextOwnerName}
          currentRole={currentRole}
          isVisibleOwnerRole={false}
        />
        <ButtonContainer>
          <ButtonLoader
            size="medium"
            color="blue"
            type="submit"
            variant={form.getState().dirty ? 'light-blue' : 'gray-border'}
            disabled={!form.getState().dirty}
            isPending={isPending}
          >
            Save
          </ButtonLoader>
          <Button size="medium" variant="gray-system" onClick={onClose}>
            Close
          </Button>
        </ButtonContainer>
      </form>
    )}
    {...props}
  />
);

export default TeamRolesForm;
